export default __webpack_public_path__ + "static/media/vk_icon.2cc4c053.svg";